import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import {
  DescriptionField,
  DueDatePicker,
  ReminderSelector,
  SetAsExpectedClosingDateCheckbox,
  SetAsNextActionDateCheckbox,
  StartDatePicker,
  SubjectField,
  TypeSelector,
} from '@user/features/Activity/components/ActivityForm/Fields'
import type { ENTITY_TYPES } from '@sales-center/common'
import { ActivityOwnerField } from './ActivityOwnerField'
import type { OwnerOption } from './ActivityFormFields.types'

type Props = {
  salesTeamId: number
  ownerId?: string
  owners?: OwnerOption[]
  entityType: ENTITY_TYPES
  isBulk: boolean
  canUpdate: boolean
  showExpectedClosingDate: boolean
  reminderDisabled: boolean
}

// Entity-scoped activity create (Lead/Opportunity detail, bulk). Layout unchanged
// from the original ActivityFormFields — extracted so the parent stays small.
export function ActivityFormFieldsDefault(props: Props) {
  const {
    salesTeamId,
    ownerId,
    owners,
    entityType,
    isBulk,
    canUpdate,
    showExpectedClosingDate,
    reminderDisabled,
  } = props

  return (
    <Box>
      <Stack direction="column" p={0}>
        <Box>
          <SubjectField />
        </Box>
        <Box>
          <TypeSelector />
        </Box>
        {!isBulk && (
          <Box>
            <ActivityOwnerField
              salesTeamId={salesTeamId}
              ownerId={ownerId}
              owners={owners}
              entityType={entityType}
            />
          </Box>
        )}
        <Box>
          <StartDatePicker />
        </Box>
        <Box>
          <DueDatePicker />
        </Box>

        <Box ml={1}>
          {canUpdate && (
            <>
              <SetAsNextActionDateCheckbox />
              {showExpectedClosingDate && <SetAsExpectedClosingDateCheckbox />}
            </>
          )}
        </Box>

        <Box>
          <DescriptionField mt={canUpdate ? 0 : 2} />
        </Box>
        <Box>
          <ReminderSelector disabled={reminderDisabled} />
        </Box>
      </Stack>
    </Box>
  )
}
